module.exports = ":host {\n  width: 100%;\n  height: 100%; }\n\n.pointer {\n  cursor: pointer;\n  font-size: 12px; }\n"